import React, { FC } from 'react';

import useJoiValidation from '../hooks/useJoiValidation';
import { ImageVideoResourceComponentSchema } from './ImageVideoResourceComponent.schema';
import { IImageVideoResourceComponentProps, Image, IResourceCardProps } from './models';
import ResourceCard from './ResourceCard';
import './style.scss';

const ImageVideoResourceComponent: FC<IImageVideoResourceComponentProps> = (props) => {
    const { data, }: { data: IImageVideoResourceComponentProps; } = useJoiValidation(ImageVideoResourceComponentSchema, 'ImageinteractiveComponent', props);

    function transformToStructuredData(data) {
        const resourcesArray: IResourceCardProps[] = [];
        for (let i = 1; i <= 4; i++) {
            resourcesArray.push({
                resourceImg: (data as IImageVideoResourceComponentProps)[`resourceImg${i}`] as Image,
                resourceImgAlt: (data as IImageVideoResourceComponentProps)[`resourceImgAlt${i}`] as string,
                resourceTitle: (data as IImageVideoResourceComponentProps)[`resourceTitle${i}`] as string,
                resourceDescription: (data as IImageVideoResourceComponentProps)[`resourceDescription${i}`] as string,
                resourceLinkName: (data as IImageVideoResourceComponentProps)[`resourceLinkName${i}`] as string,
                resourceUrl: (data as IImageVideoResourceComponentProps)[`resourceUrl${i}`] as string,
                isResourceVideo: (data as IImageVideoResourceComponentProps)[`isResourceVideo${i}`] as boolean,
            });
        }

        return {
            title: data.title,
            description: data.description,
            resources: resourcesArray,
        };
    }

    const dataArray = transformToStructuredData(data);

    return (
        <div className="cds-section cds-page-block resource-cards">
            <div className="resource-cards__container">
                <div className="cds-container">
                    {dataArray?.title && <h2 className='resource-cards__title'>{dataArray.title}</h2>}
                    {dataArray?.description && <p className='resource-cards__desc'>{dataArray.description} </p>}
                    <div className="resource-cards__items">
                        {dataArray?.resources?.map((item) => (
                            <ResourceCard
                                resourceImg={item.resourceImg}
                                resourceTitle={item.resourceTitle}
                                resourceDescription={item.resourceDescription}
                                resourceLinkName={item.resourceLinkName}
                                resourceUrl={item.resourceUrl}
                                isResourceVideo={item.isResourceVideo}
                                resourceImgAlt={item.resourceImgAlt}
                            />
                        )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageVideoResourceComponent;
